import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isNumeric',
    standalone: false,
})
export class IsNumericPipe implements PipeTransform {
    constructor() {}

    transform(input: any): boolean {
        return typeof input == 'number' || (typeof input == 'string' && input.length > 0 && !isNaN(Number(input)));
    }
}
